import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { selectAuth, setToken } from "./store/login.Slice";
import { login } from "./store/LoginAPI";
import { styled } from "@mui/material/styles";
import above from "../../../assets/images/above.png";
import below from "../../../assets/images/below.png";
import Button from "../../Components/Button";
import { useNavigate } from "react-router-dom";
import { getLsItem } from "../../Utils";
import { Container } from "@mui/material";
import "./style.css";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useAppDispatch();
  const auth = useAppSelector(selectAuth);
  const navigator = useNavigate();

  const handleLogin = () => {
    dispatch(setToken("asddddddddddddddddddasd"));
    navigator("/dashboard", { replace: true });
  };

  return (
    <LoginGrid className="colorfull">
      <PaddingMargin className="colorfull">
        <Typography sx={{ fontSize: "40px" }} gutterBottom>
          Welcome Back
        </Typography>
        <Typography
          sx={{ fontSize: "16px", color: "#6C717C" }}
          variant="subtitle1"
          gutterBottom
        >
          Welcome back! Please enter your details.
        </Typography>
        <Box component="form" noValidate autoComplete="off">
          <FlexCol>
            <Typography sx={{ fontSize: "16px", marginTop: "54px" }}>
              Username
            </Typography>
            <TextField
              // InputLabelProps={{
              //   style: {
              //     color: "green",
              //   },
              // }}
              sx={{ width: "332px", height: "44px" }}
              type="email"
              name="email"
              required
              label="Enter your username"
              variant="outlined"
              onChange={(e) => setEmail(e.target.value)}
            />
            <Typography sx={{ fontSize: "16px", marginTop: "22px" }}>
              Password
            </Typography>
            <TextField
              sx={{ width: "332px", height: "44px" }}
              required
              type="password"
              label="password"
              name="password"
              variant="outlined"
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              disabled={email && password != "" ? false : true}
              sx={signButtonSx}
              onClick={handleLogin}
              name="Sign In"
              variant="contained"
            />
          </FlexCol>
        </Box>
      </PaddingMargin>
      <PaddingMargin
        className="image"
        style={{
          backgroundColor: "#FAFAFA",
          textAlign: "center",
        }}
      >
        <img src={above} alt="" />
        <br />
        <img src={below} alt="" />
      </PaddingMargin>
    </LoginGrid>
  );
};

export default LoginPage;

export const LoginGrid = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column-reverse",
    alignContent: "center",
    alignItems: "center",
  },
}));

export const FlexCol = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: "10px",
});

export const PaddingMargin = styled("div")(({ theme }) => ({
  paddingTop: "233px",
  paddingBottom: "233px",
  paddingLeft: "200px",
  paddingRight: "200px",
  [theme.breakpoints.down("md")]: {
    paddingTop: "100px",
    paddingBottom: "100px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
}));

export const signButtonSx = {
  backgroundColor: "#2DAAE1",
  width: "332px",
  height: "44px",
  borderRadius: "5px",
  fontSize: "18px",
  color: "white",
  marginTop: "26px",
  cursor: "pointer",
};
